import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const ensureStyleGuideAnalysis = api(async function ensureStyleGuideAnalysis({
    projectId,
    scheduleId,
    force = false,
}) {
    return mutate(
        gql`
            mutation EnsureStyleGuideAnalysis($projectId: String!, $scheduleId: String!, $force: Boolean) {
                ensureStyleGuideAnalysis(projectId: $projectId, scheduleId: $scheduleId, force: $force)
            }
        `,
        { projectId, scheduleId, force },
        { returns: "ensureStyleGuideAnalysis" }
    )
})
